import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['list', 'item', 'input', 'group', 'empty']

  search(event) {
    const value = this.inputTarget.value.toLowerCase()
    this.itemTargets.forEach((elem) => {
      const data = (elem.getAttribute('data-value') || '').toLowerCase()
      elem.classList.toggle("hidden", data.search(value) < 0)
    });
    this.refreshGroupsAndEmpty()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();
    let totalVisible = 0;
    this.itemTargets.forEach(item => {
      const text = (item.getAttribute('data-value') || item.textContent).toLowerCase();
      const match = !query || text.includes(query);
      item.classList.toggle("hidden", !match);
      if (match) totalVisible++;
    });
    this.refreshGroupsAndEmpty(totalVisible)
  }

  refreshGroupsAndEmpty(totalVisible) {
    if (this.hasGroupTarget) {
      this.groupTargets.forEach(group => {
        const visible = group.querySelectorAll('[data-search-target="item"]:not(.hidden)').length;
        group.classList.toggle("hidden", visible === 0);
      });
    }
    if (this.hasEmptyTarget) {
      const count = (typeof totalVisible === 'number')
        ? totalVisible
        : this.itemTargets.filter(i => !i.classList.contains('hidden')).length;
      this.emptyTarget.classList.toggle("hidden", count > 0);
    }
  }
}
